

























































import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import Vue from 'vue'
import { mixins } from 'vue-class-component'

import { taskPriorityColor, taskStatusColor, taskStatus, taskPriority, taskPriorityValues, taskStatusValues } from '@/modules/Task/helpers/task'
import TaskDialog from '@/modules/Task/scripts/task-dialog'
import AppCheckbox from '@/components/AppCheckbox.vue'
import { Task, TaskStatus } from '@/modules/Task/interfaces/task'
import { dateToDisplay } from '@/utils/dateTime'
import { Case } from '@/modules/Newcase/interfaces/case'
import CaseCompletedDrawer from '@/modules/Newcase/components/CaseCompletedDrawer.vue'
import CaseTaskDetailDrawer from '@/modules/Newcase/components/CaseTaskDetailDrawer.vue'
import CaseDialog from '../scripts/case-dialog'

@Component({
  components: {
    AppCheckbox,
    CaseCompletedDrawer,
    CaseTaskDetailDrawer
  }
})
export default class CaseDetailTask extends mixins(CaseDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  taskPriorityColor = taskPriorityColor
  taskStatusColor = taskStatusColor
  taskStatus = taskStatus
  taskPriority = taskPriority
  taskPriorityValues = taskPriorityValues
  taskStatusValues = taskStatusValues
  dateToDisplay = dateToDisplay
  TaskStatus = TaskStatus

  tasks: Task[] = []

  selectedIndex = -1

  completedDrawer = {
    show: false
  }

  taskDetailDrawer = {
    show: false,
    taskId: -1
  }

  async mounted () {
    this.tasks = this.caseInfo.tasks
  }

  @Watch('caseInfo', { deep: true })
  onCaseInfoChanged (val: Case) {
    this.tasks = this.caseInfo.tasks
  }

  selectTask (index: number) {

  }

  generateAssignTo (item: Task) {
    const { assignedTo } = item

    return assignedTo.reduce((prev, curr, currIdx) => {
      if (currIdx === assignedTo.length - 1) {
        return prev + curr.username
      } else {
        return prev + curr.username + ', '
      }
    }, '')
  }

  async closeCaseConfirm () {
    this.targetCase = this.caseInfo
    this.closeCaseDialog.show = false
    await this.closeCasePost()
    return this.onSuccess()
  }

  onDrawerClose () {
    this.completedDrawer.show = false
  }

  onDetailDrawerClose () {
    this.taskDetailDrawer.show = false
    this.taskDetailDrawer.taskId = -1
    this.selectedIndex = -1
  }

  onSelect (index: number, taskId: number) {
    this.selectedIndex = index
    this.taskDetailDrawer.taskId = taskId
    this.taskDetailDrawer.show = true
  }

  @Emit('refresh')
  onSuccess () {

  }

  onTaskComplete () {
    this.tasks[this.selectedIndex].status = TaskStatus.COMPLETE
  }
}
